import { render, staticRenderFns } from "./ObstacleTreatManager.vue?vue&type=template&id=53074cfe"
import script from "./ObstacleTreatManager.vue?vue&type=script&lang=js"
export * from "./ObstacleTreatManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports